import { periodFromDate } from "../../components/Lit/acc-mixins/dates.js";
import { accAPI } from "..";
import {
  EarningCalculatorBody,
  ECCalculateResponse,
  ECSettingsData,
  ECSettingsQueryParams,
} from "./earningCalculatorAPI.types";

const basePath = "/ec-v2/api";

export const ecV2API = accAPI.injectEndpoints({
  endpoints: (build) => ({
    getECSettings: build.query<ECSettingsData, ECSettingsQueryParams>({
      query: (params) => {
        const {
          AffAbo,
          Locale,
          CountryCode,
          ISOCurrencyCode,
          BFI,
          BFIRestart1,
          BFIRestart2,
          BFIFixedPayment,
          BBI,
          BBIRestart1,
          BBIRestart2,
          BBIFixedPayment,
          IsStandarRetailEnhancementCountry,
          EnableTrainingMode,
          IsCSIActive,
        } = params;

        const queryParams = new URLSearchParams({
          AffAbo,
          Period: periodFromDate(new Date()),
          Locale,
          CountryCode,
          ISOCurrencyCode,
          BFI: `${BFI}`,
          BFIRestart1: `${BFIRestart1}`,
          BFIRestart2: `${BFIRestart2}`,
          BFIFixedPayment: `${BFIFixedPayment}`,
          BBI: `${BBI}`,
          BBIRestart1: `${BBIRestart1}`,
          BBIRestart2: `${BBIRestart2}`,
          BBIFixedPayment: `${BBIFixedPayment}`,
          IsStandarRetailEnhancementCountry: `${IsStandarRetailEnhancementCountry}`,
          EnableTrainingMode: `${EnableTrainingMode}`,
          IsCSIActive: `${IsCSIActive}`,
        });
        return `${basePath}/settings?${queryParams}`;
      },
      keepUnusedDataFor: 1800, // cache up to 30 mins
    }),
    getECCalculate: build.mutation<ECCalculateResponse, EarningCalculatorBody>({
      query: (body) => ({
        url: `${basePath}/calculate`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useGetECSettingsQuery, useGetECCalculateMutation } = ecV2API;
